export default {
    van: {
        name: 'Nama',
        confirm: 'Sahkan',
        cancel: 'Batal',
    },
    app: {
        confirm: "Sahkan",
        cancel: "Batal",
        skip: "Langkau",
        request: {
            error_info: "Maklumat Ralat",
            copy: "Salin"
        },
        message: {
            hello: "Hai, Dunia"
        },
        home: {
            search_area: "Kawasan Pengedar",
            search_area_content: "Alamat Pengedar",
            gotothis: "Pergi ke sini",
            area_select: "Pilih Alamat",
            selfplace: "Lokasi Semasa",
            dealerfullname: "Nama Pengedar",
            dealeraddress: "Alamat Pengedar",
            map_store_query_title: "Carian Kedai",
            map_store_location_fallback_hint: "(Kebenaran lokasi tidak dibenarkan, gunakan alamat lalai)",
            map_store_select_province: "Pilih Negeri",
            map_store_search_province_placeholder: "Cari Negeri",
            map_store_search_store_placeholder: "Cari Nama Kedai",
            map_store_search_store_or_code_placeholder: "Cari Negeri/Nama Kedai",
            map_store_empty_line1: "Tiada kedai di negeri ini buat masa ini",
            map_store_empty_line2: "Anda boleh mencari kedai di negeri lain",
            map_store_empty_area_line1: "Tiada kedai di kawasan ini buat masa ini",
            map_store_empty_area_line2: "Anda boleh mencari kedai di kawasan lain",
            map_store_nav_button: "Navigasi",
            map_store_overview_button: "Pratonton Keseluruhan",
            map_store_refresh_button: "Muat Semula Kedai",
            map_store_all_provinces: "Semua Negeri",
            map_country_china: "China",
            map_country_malaysia: "Malaysia",
            map_region_label: "Kawasan",
            map_loading: "Peta sedang dimuatkan...",
            map_region_switch_loading: "Sedang dimuatkan, sila tunggu sebelum menukar negara",
            map_popup_auth_date_prefix: "Tarikh Kebenaran:",
            map_popup_distance_prefix: "Jarak:",
            map_popup_nav_to: "Navigasi ke",
            map_popup_copy_address: "Salin",
            map_nav_getting_location: "Mendapatkan lokasi…",
            map_nav_location_unavailable_title: "Tidak dapat mendapatkan lokasi semasa",
            map_nav_location_unavailable_message: "Tidak dapat mendapatkan lokasi semasa. Teruskan navigasi? Anda boleh memasukkan titik permulaan sendiri dalam peta.",
            map_nav_continue: "Teruskan Navigasi",
            map_nav_cancel: "Batal",
            map_nav_popup_blocked_title: "Tetingkap baharu disekat",
            map_nav_popup_blocked_message: "Pelayar menyekat tetingkap baharu. Sila klik butang di bawah untuk membuka navigasi; anda akan kekal pada halaman peta semasa.",
            map_nav_popup_blocked_open: "Buka Navigasi",
            map_nav_popup_blocked_open_current_message: "Masih tidak dapat membuka tetingkap baharu. Buka navigasi pada halaman semasa? Anda akan meninggalkan halaman peta semasa.",
            map_nav_popup_blocked_open_current: "Buka pada halaman semasa",
            map_nav_wechat_browser_title: "Sila buka dalam pelayar",
            map_nav_wechat_browser_message_ios: "Aplikasi peta tidak dapat dibuka terus dalam WeChat. Sila klik \"···\" di penjuru kanan atas, pilih \"Buka dalam Safari\", kemudian klik navigasi semula.",
            map_nav_wechat_browser_message_android: "Aplikasi peta tidak dapat dibuka terus dalam WeChat. Sila klik \"···\" di penjuru kanan atas, pilih \"Buka dalam pelayar\", kemudian klik navigasi semula.",
            map_nav_wechat_browser_confirm: "Faham",
            map_nav_ios_map_apple: "Peta Apple",
            map_nav_ios_map_google: "Peta Google",
            map_nav_ios_map_picker_title: "Pilih Aplikasi Navigasi",
            map_geo_unsupported: "Pelayar semasa tidak menyokong pengesanan lokasi",
            map_geo_failed: "Gagal mendapatkan lokasi",
            map_geo_permission_denied: "Kebenaran lokasi ditolak",
            map_geo_unavailable: "Tidak dapat mendapatkan lokasi buat sementara ini",
            map_geo_timeout: "Masa tamat untuk lokasi",
            map_popup_location_error: "Lokasi kedai tidak normal",
            map_geolocation_watchdog_timeout: "Masa tamat untuk lokasi, kawasan lalai telah digunakan"
        },
        scheme: {
            nomoredata: "Tiada lagi",
            author: "Pengarang"
        },
        schemedetail: {
            errordata: "Data tidak normal"
        },
        login: {
            user_type: "Jenis Pengguna",
            user_type_placeholder: "Sila pilih jenis pengguna",
            phone: "Nombor Telefon",
            phone_placeholder: "Sila masukkan nombor telefon",
            code: "Kod Pengesahan SMS",
            code_placeholder: "Kod Pengesahan SMS",
            send_code: "Hantar Kod Pengesahan",
            login: "Log Masuk",
            phone_verify: "Sila masukkan nombor telefon yang betul",
            imagecode_verify: "Sila masukkan kod pengesahan grafik",
            send_code_finish: "Kod pengesahan telah dihantar",
            code_count: "saat untuk hantar semula",
            login_success: "Log masuk berjaya",
            user_type_person: "Individu",
            user_type_dealer: "Peniaga",
            captcha: "Kod Pengesahan Grafik",
            captcha_placeholder: "Kod Pengesahan Grafik",
            user_registe: "Pendaftaran Pengguna",
            dealer_user_registe: "Pendaftaran Pengguna Peniaga",
            dealer_registe: "Pendaftaran Peniaga",
            gotoregister: "Sila daftar dahulu",
            selectaccount: "Pilih Akaun",
            roleregister: "Daftar",
            input_sms_code: "Sila masukkan kod pengesahan SMS",
            quick_register_title: "Lengkapkan profil anda",
            quick_register_subtitle: "Nombor telefon ini belum didaftarkan.\nTetapkan nama pengguna untuk mendaftar dan log masuk.",
            quick_register_name_label: "Nama Pengguna",
            quick_register_name_placeholder: "Isi nama pengguna",
            quick_register_name_required: "Sila isi nama pengguna dahulu",
            quick_register_confirm: "Daftar & Log Masuk"
        },
        dealerregister: {
            dealer_register: "Pendaftaran Pengedar",
            dealerType: "Peniaga",
            dealerAddress: "Pilih Kawasan",
            dealerFullAddress: "Alamat Pengedar",
            dealerName: "Nama Penuh Peniaga",
            dealerShortName: "Nama Ringkas Peniaga",
            dealerNamePlaceHolder: "Sila masukkan nama peniaga",
            userName: "Nama Orang Hubungan",
            userEmail: "E-mel Orang Hubungan",
            userPhone: "Nombor Telefon Orang Hubungan",
            phone: "Nombor Telefon",
            imageCode: "Kod Pengesahan Grafik",
            register: "Daftar",
            login: "Sudah ada akaun, pergi log masuk",
            dealerBrand: "Jenama Peniaga",
            dealerSuperiorName: "Pengedar Atasan",
            dealerSuperiorNamePlaceHolder: "Jika tiada pengedar atasan, sila abaikan",
            tips: "*Selepas menghantar maklumat pendaftaran, ia perlu melalui semakan dan kelulusan.\n(Bergantung pada keadaan, kakitangan kami akan menjalankan semakan dalam talian atau semakan di tapak.)",
            oemdealer: "OEM",
            dealer: "Pengedar",
            channel: 'Saluran Sahaja',
            business_license: "Lesen Perniagaan",
            business_registration_certificate: "Sijil Pendaftaran Perniagaan",
            business_license_code: "Kod Kredit Sosial Bersatu",
            business_registration_certificate_code: "Nombor Pendaftaran Perniagaan"
        },
        dealeruserregister: {
            dealer_user_register: "Pendaftaran Pengguna Peniaga",
            dealerType: "Peniaga",
            dealerTypePlaceHolder: "Sila pilih peniaga",
            userName: "Nama",
            userNamePlaceHolder: "Sila masukkan nama",
            userEmail: "E-mel",
            userEmailPlaceHolder: "Sila masukkan e-mel",
            userPhone: "Nombor Telefon",
            userPhonePlaceHolder: "Sila masukkan nombor telefon",
            imageCode: "Kod Pengesahan Grafik",
            register: "Daftar",
            dealerRegister: "Daftar Peniaga",
            login: "Sudah ada akaun, pergi log masuk",
            dealerTypeSelectTips: "Tiada peniaga, sila daftar peniaga dahulu"
        },
        userregister: {
            user_register: "Pendaftaran Pengguna",
            userName: "Nama",
            userNamePlaceHolder: "Sila masukkan nama",
            userEmail: "E-mel",
            userEmailPlaceHolder: "Sila masukkan e-mel",
            userPhone: "Nombor Telefon",
            userPhonePlaceHolder: "Sila masukkan nombor telefon",
            imageCode: "Kod Pengesahan Grafik",
            register: "Daftar",
            login: "Sudah ada akaun, pergi log masuk",
            register_success: "Pendaftaran berjaya"
        },
        qa: {
            qaform: {
                carinfo: "Maklumat Kenderaan",
                brand: "Jenama Kereta",
                brandPlaceHolder: "Jenama Kereta",
                carstyle: "Model Kereta",
                carstylePlaceHolder: "Model Kereta",
                carNo: "Nombor Plat",
                carNoPlaceHolder: "Nombor Plat",
                carCjNo: "Nombor Casis",
                carCjNoPlaceHolder: "Nombor Casis",
                carOwnerName: "Nama Pemilik",
                carOwnerNamePlaceHolder: "Nama Pemilik",
                phoneNumber: "Nombor Telefon",
                phoneNumberPlaceHolder: "Nombor Telefon",
                ownerphoneNumberPlaceHolder: "Nombor Telefon Pemilik",
                productinfo: "Maklumat Produk",
                productName: "Produk",
                productNamePlaceHolder: "Produk",
                productNo: "Nombor Gulungan",
                productNoPlaceHolder: "Nombor Gulungan",
                productExpire: "Waranti",
                productExpirePlaceHolder: "Waranti",
                scanProductInfo: "Imbas untuk mendapatkan maklumat produk",
                doForminfo: "Maklumat Pemasangan",
                doDate: "Tarikh",
                doValidDate: "Tarikh Pemasangan",
                doDatePlaceHolder: "Klik untuk memilih tarikh",
                getProductInfo: "Sila dapatkan maklumat produk dahulu",
                fullcar: "Pilih Semua",
                doCarShop: "Kedai",
                doCarShopPlaceHolder: "Klik untuk memilih kedai",
                doPrice: "Harga",
                doPricePlaceHolder: "Sila masukkan amaun transaksi sebenar",
                qacarcontent: "Kandungan Waranti",
                qacarimage: "Gambar Pemasangan",
                qacarzhengmian: "Gambar Pemasangan Hadapan",
                qacarcemian: "Gambar Pemasangan Sisi",
                qacarbeimian: "Gambar Pemasangan Belakang",
                qacarshop: "Gambar Kenderaan & Tanda Kedai",
                qacarjuanhao: "Gambar Nombor Gulungan Jelas",
                qacarjuanhaoandcar: "Gambar Nombor Gulungan & Kenderaan",
                submit: "Hantar",
                qaformsuccess: "Penciptaan berjaya",
                imagemustsix: "Sila muat naik enam gambar",
                productinfo_first: "(Sila imbas untuk mendapatkan maklumat produk dahulu)",
                warranty_days: "hari",
                warranty_year: "tahun",
                contact_customer_service: "Hubungi Khidmat Pelanggan",
                contact_customer_service_wechat: "Khidmat Pelanggan WeChat",
                contact_customer_service_wechat_click: "Klik untuk menghubungi khidmat pelanggan",
                contact_customer_service_phone: "Khidmat Pelanggan Telefon"
            },
            qasearch: {
                searchcontent: "Cari kad waranti melalui nombor telefon",
                phone: "Nombor Telefon",
                phonePlaceHolder: "Sila masukkan nombor telefon",
                imageCode: "Kod Pengesahan Grafik",
                imageCodePlaceHolder: "Kod Pengesahan Grafik",
                search: "Cari",
                qalist: "Senarai Waranti",
                noqatips: "Tiada waranti untuk nombor telefon ini buat masa ini"
            },
            qareview: {
                reviewtab: "Belum Disemak",
                reviewing: "Dalam Semakan",
                success: "Telah Disemak",
                failed: "Ditolak",
                submitsuccess: "Penghantaran berjaya",
                submit: "Hantar",
                reviewsuccess: "Semakan diluluskan",
                reviewfailed: "Semakan ditolak",
                review: "Semakan",
                dateStart: "Tarikh Dari",
                dateEnd: "Tarikh Hingga",
                searchtips: "Carian Kabur",
                searchtipsPlaceHolder: "Sila masukkan kata kunci",
                search: "Cari",
                reject_reason: "Sebab Penolakan",
                reject_reason_placeholder: "Sila masukkan sebab penolakan"
            },
            qadetail: {
                carinfo: "Maklumat Kenderaan",
                brand: "Jenama Kereta",
                carstyle: "Model Kereta",
                carNo: "Nombor Plat",
                carCjNo: "Nombor Casis",
                carOwnerName: "Nama Pemilik",
                phoneNumber: "Nombor Telefon",
                productinfo: "Maklumat Produk",
                productName: "Produk",
                productNo: "Nombor Gulungan",
                productExpire: "Waranti",
                doForminfo: "Maklumat Pemasangan",
                doDate: "Tarikh",
                doPart: "Bahagian Pemasangan",
                doCarShop: "Kedai",
                doPrice: "Harga",
                qacarcontent: "Kandungan Waranti",
                qacarimage: "Gambar Pemasangan",
                qacarzhengmian: "Gambar Pemasangan Hadapan",
                qacarcemian: "Gambar Pemasangan Sisi",
                qacarbeimian: "Gambar Pemasangan Belakang",
                qacarshop: "Gambar Kenderaan & Tanda Kedai",
                qacarjuanhao: "Gambar Nombor Gulungan Jelas",
                qacarjuanhaoandcar: "Gambar Nombor Gulungan & Kenderaan"
            },
            qaitem: {
                id: "ID Kad Waranti",
                warrantyCode: "Kod Waranti",
                starttime: "Tarikh Mula Waranti",
                createtime: "Tarikh Penciptaan Waranti",
                car: "Kereta",
                product: "Produk",
                status_not_confired: "Belum Disahkan",
                status_confirming: "Dalam Pengesahan",
                status_confirmed: "Telah Disahkan",
                status_rejected: "Ditolak"
            }
        },
        stock: {
            stockin: "Dalam Stok",
            stockrecord: "Rekod Kemasukan",
            stockused: "Telah Dikeluarkan",
            stockunin: "Menunggu Kemasukan",
            stockinsuccess: "Kemasukan berjaya",
            stockoutsuccess: "Pengeluaran berjaya",
            stockscancode: "Imbas untuk Kemasukan",
            stockid: "ID Stok",
            stock_stock_in: "Kemasukan",
            stock_stock_out: "Pengeluaran"
        },
        language: {
            btn_complete: "Selesai",
            switch_label: "Tukar Bahasa",
            simplified: "Cina Ringkas",
            traditional: "Cina Tradisional",
            english: "English",
            malay: "Bahasa Melayu"
        },
        mine: {
            username: "Nama Pengguna",
            changerole: "Tukar Peranan",
            changerolddesc: "Adakah anda mahu menukar peranan?",
            norolecanchagen: "Tiada peranan untuk ditukar"
        },
        mineitem: {
            myqaitem: "Waranti Saya",
            mysecuritycheckitem: "Pengesahan Nombor Siri",
            myshopitem: "Pelan Pembelian Saya",
            mystockitem: "Pengurusan Stok",
            mygoodsitem: "Pengurusan Penghantaran",
            myqareviewitem: "Pengurusan Waranti",
            mydealermanageritem: "Pengurusan Pengedar/Peruncit",
            myconstructionitem: "Pengurusan Pemasangan",
            mycouponitem: "Kupon Saya",
            couponmanageitem: "Pengurusan Kupon",
            mycouponcheckitem: "Penebusan Kupon",
            mycouponreportitem: "Laporan Kupon",
            myinstructionitem: "Manual",
            mylanguageitem: "Tukar Bahasa",
            mychartqaitem: "Laporan Waranti",
            mychartpurchaseorderitem: "Laporan Pesanan Pembelian",
            workerlist: "Pengurusan Pekerja",
            workerdetail: "Maklumat Pekerja",
            mystockinitem: "Pengurusan Kemasukan",
            mycreatestockitem: "Cipta Stok",
            mystockoutitem: "Pengurusan Pengeluaran",
            mycreateqaitem: "Cipta Waranti",
            myqueryqaitem: "Siasatan Waranti",
            myclaimitem: "Tuntutan",
            myclaimapprovalitem: "Kelulusan Tuntutan",
            mycompensationitem: "Pengurusan Pampasan",
            myorderitem: "Pengurusan Pelan Pembelian Peringkat Bawah",
            mylogout: "Log Keluar",
            myloginin: "Log Masuk",
            mypaymentorderitem: "Pesanan Pembelian",
            mypaymentordermanageritem: "Pengurusan Pesanan Pembelian",
            mypaymentorderbillmanageritem: "Pengurusan Slip Pembayaran",
            myproductpurchaseitem: "Beli Produk",
            wechat_purchase_hint: 'WeChat tidak dapat melancarkan Alipay secara langsung. Ketik "···" di penjuru kanan atas, pilih "Buka dalam Pelayar", kemudian pilih produk untuk membayar.',
            myservicecentermanager: "Pengurusan Pusat Servis",
            addressmanager: "Pengurusan Alamat",
            warehousemanager: "Pengurusan Gudang",
            reportmanager: "Laporan Perniagaan",
            storemanager: "Pengurusan Kedai",
            myservicepurchase: "Pembelian Perkhidmatan"
        },
        nav: {
            qalist: "Senarai Waranti",
            qacreate: "Penciptaan Waranti",
            securitycheck: "Pengesahan Nombor Siri",
            qadetail: "Butiran Waranti",
            showlist: "Senarai Pembelian",
            showorderlist: "Senarai Transaksi",
            storelist: "Senarai Kedai",
            showorder: "Pesanan Pembelian",
            shopdetail: "Butiran Pembelian",
            shoporderdetail: "Butiran Transaksi",
            stock: "Pengurusan Stok",
            stockin: "Pengurusan Kemasukan",
            stockout: "Pengurusan Pengeluaran",
            purchase: "Pengurusan Penghantaran",
            purchasedetail: "Butiran Penghantaran",
            qareview: "Pengurusan Waranti",
            dealershopmanager: "Pengurusan Pengedar/Peruncit",
            dealershopmanagerdetail: "Butiran",
            qasearch: "Carian Waranti",
            qapublicquery: "Siasatan Waranti Filem Kereta",
            register: "Daftar",
            scancode: "Imbas",
            detail: "Butiran",
            languagechange: "Tukar Bahasa",
            storecreate: "Penciptaan Kedai",
            dealercreate: "Penciptaan Peniaga",
            construction: "Pengurusan Pemasangan",
            construction_pending: "Menunggu Pemasangan",
            construction_completed: "Pemasangan Selesai",
            construction_accepted: "Pemeriksaan Pemasangan",
            construction_detail: "Butiran Pemasangan",
            coupon: "Kupon Saya",
            coupon_manage: "Pengurusan Kupon",
            coupon_detail: "Butiran Kupon",
            coupon_check: "Penebusan Kupon",
            charts_coupon: "Laporan Kupon",
            manual: "Manual",
            charts_qa: "Laporan Waranti",
            charts_po: "Laporan Pesanan Pembelian",
            charts_inoutstock: "Laporan Kemasukan & Pengeluaran",
            role_select: "Pilih Identiti",
            dealer_register: "Pendaftaran Pengedar",
            direct_vender_register: "Pendaftaran Pengedar Terus",
            dealer_shop_register: "Pendaftaran Peruncit",
            service_provider_register: "Pendaftaran Penyedia Perkhidmatan",
            register_address_map: "Pilih Alamat Khusus",
            dealer_worker_register: "Pendaftaran Pekerja Pengedar",
            service_worker_register: "Pendaftaran Pekerja Penyedia Perkhidmatan",
            shop_worker_register: "Pendaftaran Pekerja Peruncit",
            consumer_user_register: "Pendaftaran Pengguna",
            qrcode_register: "Pendaftaran Imbas",
            workerlist: "Pengurusan Pekerja",
            workerdetail: "Maklumat Pekerja",
            purchase_order: "Pengurusan Pesanan",
            purchase_order_detail: "Butiran Pesanan",
            in_stock_detail: "Butiran Kemasukan",
            paymentorderbill: "Senarai Slip Pembayaran",
            paymentorderbilldetail: "Butiran Slip Pembayaran",
            scandetail: "Butiran Imbasan",
            stockoutdetail: "Butiran Pengeluaran",
            stockindetail: "Butiran Kemasukan",
            stockstockdetail: "Butiran Stok",
            servicecentermanager: "Pengurusan Pusat Servis",
            servicecentercreate: "Penciptaan Pusat Servis",
            servicecenterdetail: "Maklumat Pusat Servis",
            addressmanager: "Pengurusan Alamat",
            addresscreate: "Cipta Alamat",
            addressdetail: "Butiran",
            warehousemanager: "Pengurusan Gudang",
            warehousecreate: "Cipta Gudang",
            ordersummary: "Ringkasan Pesanan",
            orderproductout: "Pengurusan Penghantaran",
            chartslist: "Laporan Perniagaan",
            servicepurchase: "Pembelian Perkhidmatan",
            paysuccess: "Pembayaran Berjaya",
            servicelistmanager: "Pengurusan Pesanan Perkhidmatan",
            consumer_order_detail: "Butiran Pesanan",
            consumer_order_list: "Pesanan Saya",
            consumer_order_info: "Butiran Pesanan",
            consumer_payment_bill_list: "Pengurusan Pembayaran",
            consumer_payment_bill_info: "Butiran Pembayaran",
            consumer_store_list: "Pilih Kedai",
            consumer_shop: "Pilih Produk",

            claimlist: "Senarai Tuntutan",
            claimapply: "Permohonan Tuntutan",
            claimdetail: "Butiran Tuntutan",
            claimapproval: "Kelulusan Tuntutan",
            claimapprovaldetail: "Butiran Kelulusan",
            compensation: "Pampasan",
            compensationdetail: "Butiran Pampasan"
        },

        // 索赔详情
        claimdetail: {
            claimstatus: "Status Tuntutan",
            statuspending: "Menunggu Semakan",
            statusapproved: "Diluluskan",
            statusrejected: "Ditolak",
            loading: "Memuatkan...",
            applytime: "Diajukan Pada",
            approval_time: "Disemak Pada",
            approval_opinion: "Komen Semakan",
            productinfo: "Maklumat Produk",
            productname: "Nama Produk",
            product_category: "Kategori Produk",
            serialnumber: "Nombor Siri",
            compensation_party: "Pihak Pampasan",
            compensation_type: "Jenis Pihak",
            compensation_name: "Nama Pihak",
            warranty_info: "Waranti Berkaitan",
            warranty_code: "No. Waranti",
            valid_period: "Tempoh Sah",
            phone: "Telefon",
            questionnaire: "Soal Selidik",
            media: "Foto & Video",
            notfound: "Rekod tuntutan tidak ditemui",
            video_load_failed: "Gagal memuat video, sila cuba lagi"
        },

        // 索赔审批
        claimapproval: {
            all: "Semua",
            pending: "Menunggu Semakan",
            approved: "Diluluskan",
            rejected: "Ditolak",
            id: "ID",
            product_name: "Produk",
            serial_number: "Nombor Siri",
            claim_party: "Pihak Menuntut",
            warranty_code: "No. Waranti",
            empty: "Tiada rekod {label}",
            emptyall: "Tiada rekod",
            viewdetail: "Ketik untuk lihat dan semak"
        },

        // 索赔审批详情
        claimapprovaldetail: {
            flow_submitted: "Dihantar",
            claim_party_info: "Maklumat Pihak Menuntut",
            claim_party: "Pihak Menuntut",
            approve: "Luluskan",
            reject: "Tolak",
            approve_title: "Luluskan Tuntutan",
            approve_placeholder: "Masukkan sebab kelulusan…",
            approve_required: "Sila masukkan sebab kelulusan",
            reject_title: "Tolak Tuntutan",
            reject_placeholder: "Masukkan sebab penolakan…",
            reject_confirm: "Sahkan Tolak",
            cancel: "Batal",
            approve_confirm: "Sahkan Lulus",
            reject_required: "Sila masukkan sebab penolakan",
            approve_success: "Diluluskan",
            reject_success: "Ditolak",
            operate_failed: "Operasi gagal, sila cuba lagi"
        },

        // 索赔申请
        claimapply: {
            claim_type: "Jenis Tuntutan",
            link_warranty: "Pautkan Waranti",
            product_no: "Nombor Siri Produk",
            product_info: "Maklumat Produk",
            questionnaire: "Soal Selidik",
            required_select: "Wajib",
            required_fill: "Wajib",
            type_warranty: "Pautan Waranti",
            type_product: "Tuntutan Produk",
            select_warranty_placeholder: "Pilih rekod waranti",
            manual_input: "Input Manual",
            scan_input: "Imbas",
            product_no_placeholder: "Masukkan nombor siri",
            verify: "Sahkan",
            scan_hint: "Ketik untuk imbas nombor siri",
            product_category: "Kategori Produk",
            product_name: "Nama Produk",
            serial_number: "Nombor Siri",
            compensation_party: "Maklumat Pihak Pampasan",
            compensation_type: "Jenis Pihak",
            compensation_name: "Nama Pihak",
            input_placeholder: "Masukkan ",
            file_type_image: "Imej",
            file_type_video: "Video",
            multi_select_hint: "(Boleh pilih banyak)",
            check_questionnaire: "Sila semak sama ada soal selidik diisi dengan betul",
            submit: "Hantar Tuntutan",
            select_warranty: "Pilih Waranti",
            close: "Tutup",
            loading: "Memuatkan...",
            warranty_code: "Kod Waranti",
            valid_period: "Tempoh Sah",
            product: "Produk",
            phone: "Telefon",
            vin: "VIN",
            warranty_empty: "Tiada rekod waranti sepadan",
            file_min: "Sekurang-kurangnya {n}",
            file_max: "Sehingga {n}",
            file_range: "Sekurang-kurangnya {min}, sehingga {max}",
            error_required: "Medan ini wajib diisi",
            error_length: "Panjang mesti {min}~{max} aksara",
            error_number: "Nilai mesti {min}~{max}",
            error_format: "Format tidak sah",
            error_file_min: "Muat naik sekurang-kurangnya {n} fail",
            error_file_max: "Muat naik paling banyak {n} fail",
            toast_select_claim_type: "Sila pilih jenis tuntutan",
            toast_select_warranty: "Sila pilih rekod waranti",
            toast_product_no: "Sila masukkan atau imbas nombor siri",
            toast_verify_failed: "Pengesahan nombor siri gagal",
            toast_verify_success: "Pengesahan berjaya",
            toast_submit_success: "Tuntutan dihantar",
            toast_submit_failed: "Penghantaran gagal, sila cuba lagi"
        },

        // 索赔列表
        claimlist: {
            all: "Semua",
            pending: "Menunggu Semakan",
            approved: "Diluluskan",
            rejected: "Ditolak",
            serial_number: "Nombor Siri",
            compensation_party: "Pihak Pampasan",
            warranty_code: "No. Waranti",
            approval_opinion: "Komen Semakan",
            id: "ID",
            product_name: "Produk",
            empty: "Tiada rekod {label}",
            emptyall: "Tiada rekod",
            empty_sub: "Hantar tuntutan jika anda menemui isu produk",
            create: "Hantar Tuntutan"
        },

        // 消费者扫码订单（个人消费者）
        consumerorder: {
            order_no: "No. Pesanan",
            product_list: "Senarai Barang",
            product_amount: "Jumlah Barang",
            freight: "Penghantaran",
            freight_free: "Percuma",
            total_amount: "Jumlah",
            pay_amount: "Jumlah Perlu Dibayar",
            create_order: "Cipta Pesanan",
            create_payment: "Cipta Pembayaran",
            first_select_address: "Sila pilih alamat penghantaran",
            order_success: "Pesanan dibuat",
            go_to_payment: "Bayar sekarang?",
            payment_confirm: "Bayar",
            payment_back: "Kemudian",
            payment_method: "Kaedah pembayaran",
            payment_success: "Pembayaran berjaya",
            payment_failed: "Pembayaran gagal dimulakan, sila cuba sebentar lagi",
            alipay_querying: "Menyemak status pembayaran, sila tunggu…",
            alipay_back: "Kembali",
            alipay_scan_tip: "Imbas untuk membayar dengan Alipay",
            alipay_scan_sub: "Status pembayaran akan disemak secara automatik",
            company_name: "Nama syarikat",
            bank_name: "Nama bank",
            bank_account: "No. akaun",
            payment_time: "Masa pembayaran",
            payment_time_now: "Masa semasa",
            payment_time_manual: "Manual",
            select_full_date: "Pilih masa penuh",
            search_order_placeholder: "Cari mengikut ID pesanan",
            tab_all: "Semua",
            tab_unpay: "Belum dibayar",
            tab_unconfirmed: "Belum disahkan",
            tab_partpay: "Sebahagian",
            tab_payed: "Disahkan",
            tab_confirmed: "Disahkan",
            tab_closed: "Ditutup",
            status_confirmed: "Disahkan",
            status_pending_payment: "Belum Dibayar",
            status_confirming: "Belum Disahkan",
            payment_bill_manage: "Pengurusan Pembayaran",
            search_bill_placeholder: "Cari mengikut ID pembayaran",
            payment_bill_id: "ID Pembayaran",
            transaction_no: "Nombor Transaksi",
            payment_subject_type: "Jenis Pembayar",
            payment_subject: "Pembayar",
            receive_account: "Akaun Penerimaan",
            payment_amount: "Amaun Pembayaran",
            order_id: "ID Pesanan",
            order_person: "Pembeli",
            order_date: "Masa pesanan",
            order_info: "Maklumat pesanan",
            order_status: "Status",
            order_time: "Masa pesanan",
            price_detail: "Butiran amaun",
            really_pay: "Jumlah dibayar",
            order_payment: "Maklumat pembayaran",
            related_order: "Pesanan Berkaitan",
            create_pay_time: "Masa dicipta",
            payment_date: "Masa pembayaran",
            confirm_date: "Masa pengesahan",
            loading: "Memuatkan…",
            empty: "Tiada pesanan",
            empty_hint: "Cuba status lain, atau imbas untuk buat pesanan",
            retailer: "Peruncit",
            retailer_id: "ID Peruncit",
            includes: "Termasuk",
            logistics_need: "Perlu penghantaran",
            logistics_none: "Tiada penghantaran",
            logistics_optional: "Pilihan",
            delivery_title: "Cara penghantaran",
            delivery_need: "Perlu dihantar",
            delivery_none: "Tidak perlu",
            no_delivery_hint: "Tiada penghantaran diperlukan",
            no_delivery_desc:
                "Tiada alamat penghantaran diperlukan. Anda boleh terus membuat pesanan.",
            leave_confirm:
                "Anda perlu mengimbas kod QR semula untuk kembali ke halaman ini",
            leave_confirm_ok: "Keluar",
            leave_confirm_cancel: "Kekal di sini",
            consumer_only_hint: "Halaman ini hanya untuk pengguna individu. Akaun anda tiada akses.",
            consumer_only_confirm: "OK",
            data_error: "Data tidak normal",
            retailer_select_title: "Pilih Peruncit",
            retailer_placeholder: "Sila pilih peruncit",
            retailer_search_placeholder: "Cari nama kedai",
            retailer_locating: "Sedang mendapatkan lokasi…",
            retailer_empty: "Tiada peruncit ditemui",
            shop_search_placeholder: "Cari nama kedai",
            shop_empty: "Tiada kedai ditemui",
            empty_product: "Tiada produk",
            retailer_required: "Sila pilih peruncit dahulu",
            retailer_change: "Tukar",
            alipay_wechat_guide_title: "Buka dalam pelayar untuk melengkapkan pembayaran",
            alipay_wechat_guide_desc: "WeChat tidak dapat membuka Alipay secara terus. Ikut langkah berikut:",
            alipay_wechat_guide_step1: "Ketik ··· di penjuru kanan atas",
            alipay_wechat_guide_step2: "Pilih Buka dalam pelayar",
            alipay_wechat_guide_step3: "Ketik Bayar semula untuk melengkapkan",
            alipay_wechat_pay_message: "WeChat tidak dapat membuka Alipay secara terus. Ketik ··· di penjuru kanan atas dan pilih Buka dalam pelayar untuk membayar semula, atau guna pindahan bank.",
            alipay_wechat_pay_confirm: "Faham"
        },
        shop: {
            order: "Buat Pesanan",
            clearcart: "Kosongkan Troli",
            selectall: "Pilih Semua",
            addCart: "Sila pilih spesifikasi dahulu",
            shopsuccess: "Pesanan Berjaya",
            addToCartFirst: "Sila tambah ke troli dahulu",
            shoplistid: "ID Pesanan Pembelian",
            showlisttime: "Tarikh Pembelian",
            showlistdealer: "Peniaga",
            showlistphone: "Nombor Telefon Pembeli",
            getshop: "Pembelian",
            addToCart: "Tambah ke Troli",
            product_detail: "Butiran Produk",
            no_detail: "Tiada butiran",
            view_detail: "Lihat Butiran",
            allproduct: "Kuantiti",
            allprice: "Jumlah",
            order_status_unreview: "Dalam Pengesahan Bayaran",
            price_begin: "mulai",
            nopermission: "Pengguna bukan ejen tidak dibenarkan melihat maklumat produk",
            popup_confirm: "Kembali ke Laman Web Rasmi",
            popup_changerole: "Tukar Peranan",
            purchase_people: "Pembeli",
            purchase_from: "Pihak Pembeli",
            confirm_order: "Sahkan Pesanan"
        },
        account: {
            title: "Maklumat Akaun Pemindahan Wang",
            companynametitle: "Nama Syarikat",
            companynamevalue: "Shanghai Guangtai Qiaozi Industrial Development Co., Ltd.",
            tintitle: "Nombor Pengenalan Pembayar Cukai",
            tinvalue: "91310118560192303A",
            addresstitle: "Alamat",
            addressvalue: "Bilik 320, No. 45, Lorong 16, Jalan Xiangningbang, Pekan Zhujiajiao, Daerah Qingpu",
            phonetitle: "Telefon",
            phonevalue: "64188908",
            banktitle: "Bank Pembukaan Akaun",
            bankvalue: "Cawangan Weihai Road Shanghai, Bank Pertanian China",
            accounttitle: "Nombor Akaun Pemindahan",
            accountvalue: "03304700040011734",

            merchantnotitle: "Nombor Pedagang",
            parentmerchantnotitle: "Nombor Pedagang Induk",
            nopaymentmethod: "Tiada kaedah pembayaran",
            alipay: "Alipay",
            banktransfer: "Pindahan Bank",
            tips: "*Selepas membuat pesanan, maklumat akaun pemindahan boleh disemak pada halaman butiran pembelian"
        },
        purchase: {
            dateStart: "Tarikh Dari",
            dateEnd: "Tarikh Hingga",
            searchtips: "Carian Kabur",
            searchtipsPlaceHolder: "Sila masukkan kata kunci",
            search: "Cari",
            unpurchase: "Belum Dihantar",
            purchased: "Telah Dihantar",
            scanstockout: "Imbas untuk Pengeluaran",
            id: "ID Pesanan Pembelian",
            time: "Masa Pembelian",
            dealer: "Pengedar Pembelian",
            dealerphonenumber: "Nombor Telefon Pengguna Pembelian",
            dealername: "Nama Pengedar",
            dealeraddress: "Alamat Pengedar",
            dealercontactname: "Nama Orang Hubungan",
            dealercontactphone: "Nombor Telefon Orang Hubungan",
            dealerinfo: "Maklumat Peniaga",
            productinfo: "Maklumat Produk",
            gopurchase: "Pembelian",
            search_input_purchase_placeholder: "Sila masukkan ID pesanan pembelian untuk carian",
            purchase_list: "Senarai Pembelian",
            to_now: "sehingga kini"
        },
        purchasedetail: {
            goodsinfo: "Maklumat Barangan",
            bankinfo: "Maklumat Pemindahan"
        },
        securitycheck: {
            securitycheckscancode: "Imbas untuk Menyemak Kesahihan",
            productscan: "Nombor Siri Produk",
            resultsuccess: "Produk Tulen Disahkan",
            resulterror: "Barangan Tiruan",
            resulterrortwo: "Nombor siri ini tidak ditemui buat masa ini",
            resulterrordetail: "Sistem tidak dapat memadankan nombor siri yang anda masukkan. Sila hubungi peruncit atau pengedar atasan anda untuk pengesahan manual dan mendapatkan maklum balas produk yang terperinci.",
            tips: "Selepas mendaftar waranti elektronik, anda menikmati waranti rasmi dan pelbagai perkhidmatan nilai tambah",
            thanks: "Tahniah! Produk ini ialah filem kereta tulen Castrol\nTerima kasih atas sokongan anda!",
            thankserror: "Sila hubungi pihak rasmi untuk pemprosesan",
            thankserrortwo: "Sistem tidak dapat memadankan nombor siri yang anda masukkan\nSila hubungi peruncit atau pengedar atasan anda untuk pengesahan manual dan mendapatkan maklum balas produk yang terperinci.",
            jump: "Teruskan",
            productverify: "Pengesahan Keaslian Produk",
            productstyle: "Model Produk",
            expire: "Tempoh Waranti",
            qacreate: "Cipta Waranti"
        },
        qrcode: {
            cameraname: "Kamera",
            selectcamera: "Pilih Kamera",
            tips: "Masalah dengan imbasan? Klik untuk menukar kamera",
            btntips: "Tukar",
            fromalbum: "Pilih dari Album",
            imageverifyerror: "Gagal mengecam imej",
            initerror: "Gagal memulakan penghurai",
            changecamera: "Tukar Kamera",
            album: "Album",
            scan_end: "Tamat Imbasan",
            scan_preview: "Pratonton Imbasan",
            scan_summary: "Ringkasan Imbasan",
            scan_success: "Imbasan Berjaya",
            please_scan_first: "Sila imbas dahulu",
            barcodetips: "Sila halakan kod bar ke dalam bingkai untuk mengimbas",
            verify_success: "Pengesahan Berjaya"
        },
        dealershopmanager: {
            dealername: "Pengedar",
            shopname: "Kedai",
            retailer: "Peruncit",
            item: {
                id: "ID",
                fullname: "Nama Penuh",
                address: "Alamat"
            },
            detail: {
                id: "ID",
                fullname: "Nama Penuh",
                address: "Alamat",
                shortname: "Nama Ringkas",
                brand: "Jenama",
                level: "Tahap",
                createtime: "Masa Penciptaan"
            },
            createshop: "Cipta Kedai",
            createdealer: "Cipta Pengedar",
            createretailer: "Cipta Peruncit",
            search_name: "Sila masukkan nama untuk mencari",

            type: {
                picker_title: "Pilih jenis peruncit",
                picker_subtitle: "Pilih jenis peruncit untuk dicipta",
                retailer: "Peruncit standard",
                retailer_desc: "Perkhidmatan jualan dan pemasangan",
                sales_only: "Peruncit jualan sahaja",
                sales_only_desc: "Jualan sahaja, tanpa pemasangan",
                sales_only_short: "Jualan sahaja",
                cancel: "Batal"
            },
            shop: {
                title: "Butiran Kedai",
                shopinfo: "Maklumat Kedai",
                shopname: "Nama Ringkas Kedai",
                shopfullname: "Nama Penuh Kedai",
                shopaddress: "Alamat Kedai",
                shopphonenumber: "Nombor Telefon Orang Hubungan",
                submit: "Hantar",
                verifyone: "Lesen Perniagaan",
                dealerfullname: "Nama Penuh Peniaga",
                dealerlevel: "Tahap Peniaga",
                verifyonefront: "Fail",
                verifyoneback: "Fail",
                verifyoneshopimg: "Fail",
                emptytips: "Maklumat tidak lengkap",
                submitsuccess: "Maklumat berjaya dihantar, dalam semakan......",
                storeaddress: "Alamat Kedai"
            },
            dealer: {
                dealerinfo: "Maklumat Peniaga",
                title: "Butiran Peniaga",
                submit: "Hantar",
                nomoreimages: "Maksimum tiga gambar boleh dimuat naik",
                submitsuccess: "Maklumat berjaya dihantar, dalam semakan......"
            },
            tips: "*Selepas menghantar maklumat penciptaan, ia perlu melalui semakan dan kelulusan.\n(Bergantung pada keadaan, kakitangan kami akan menjalankan semakan dalam talian atau semakan di tapak.)",
            businessLicenseNumber: "Nombor Lesen Perniagaan"
        },
        construction: {
            order_available: "Boleh Terima Pesanan",
            order_pending_construction: "Menunggu Pemasangan",
            order_under_construction: "Dalam Pemasangan",
            order_construction_completed: "Pemasangan Selesai",
            order_accepted: "Telah Diperiksa",
            order_cancelled: "Telah Dibatalkan",
            accepted: "Pemeriksaan",
            item: {
                order_id: "Nombor Pesanan",
                color: "Warna",
                car_style: "Model Kereta",
                dealer: "Peniaga",
                construction_address: "Alamat Pemasangan",
                construction_time_area: "Julat Masa Pemasangan",
                selected_construction_time: "Masa Pemasangan Dipilih",
                construction_people: "Kakitangan Pemasangan",
                under_construction_btn_before: "Pemasangan Awal",
                under_construction_btn_after: "Mula Pemasangan"
            },
            pedding_construction: {
                title: "Adakah anda mahu memulakan pemasangan?",
                cancel: "Batal",
                confirm: "Sahkan"
            },
            constructioncompleted_detail: {
                title: "Sila muat naik gambar kenderaan selepas pemasangan",
                image: "Gambar",
                cell_title: "Item Pemeriksaan Serahan Kenderaan",
                defect_name: "Nama Kecacatan",
                bubble: "Gelembung",
                impurity: "Bendasing",
                offset_printing: "Kesan Cetakan",
                indicates_scratch: "Calar Permukaan",
                surface_wrinkle: "Kedutan Permukaan",
                surface_damage: "Kerosakan Permukaan",
                warranty_upload: "Muat Naik Waranti",
                construction_completed: "Pemasangan Selesai",
                pedding_construction_accepted: "Menunggu Pemilik Memeriksa Kenderaan",
                before_completed_tips: "Sila muat naik gambar borang penerimaan bertandatangan dahulu",
                cancel: "Batal",
                confirm: "Sahkan"
            },
            constructionaccepted_detail: {
                cell_title: "Item Pemeriksaan Serahan Kenderaan",
                defect_name: "Nama Kecacatan",
                bubble: "Gelembung",
                impurity: "Bendasing",
                offset_printing: "Kesan Cetakan",
                indicates_scratch: "Calar Permukaan",
                surface_wrinkle: "Kedutan Permukaan",
                surface_damage: "Kerosakan Permukaan",
                warranty_upload: "Muat Naik Waranti",
                images_title: "Gambar Selepas Pemasangan",
                accepted: "Pemeriksaan",
                construction_completed: "Pemasangan Selesai",
                before_completed_tips: "Sila muat naik gambar kenderaan selepas pemasangan",
                pedding_construction_accepted: "Adakah pemeriksaan diluluskan?",
                cancel: "Batal",
                confirm: "Pemeriksaan Diluluskan",
                completed_photos: "Gambar Pemasangan Selesai",
                owner_qrcode_photos: "Kod QR Penerimaan Pemilik"
            },
            construction_detail: {
                title: "Butiran Pesanan Pemasangan",
                order_id: "Nombor Pesanan",
                color: "Warna",
                car_style: "Model Kereta",
                construction_time_area: "Julat Masa Pemasangan",
                construction_address: "Alamat Pemasangan",
                selected_construction_time: "Masa Pemasangan yang Dipilih",
                salespeople_phonenumber: "Nombor Telefon Jurujual",
                owner_phonenumber: "Nombor Telefon Pemilik",
                worker: "Kakitangan Pemasangan",
                construction_part: "Bahagian Pemasangan",
                comment: "Komen",
                images_title: "Gambar Pemasangan Selesai",
                owner_images_title: "Gambar Pemeriksaan Pemasangan"
            }
        },
        coupon: {
            nav: {
                unused: "Belum Digunakan",
                used: "Telah Digunakan",
                invalid: "Tidak Sah",
                dealer_unused: "Telah Dikeluarkan",
                dealer_used: "Telah Ditebus",
                dealer_invalid: "Tidak Sah"
            },
            detail: {
                id: "ID",
                verificationcode: "Kod Penebusan",
                name: "Kupon",
                phone: "Nombor Telefon Pengguna",
                store: "Kedai Berkenaan",
                usedstore: "Kedai Penggunaan",
                date: "Tarikh Berkenaan",
                state: "Status",
                check_time: "Masa Penebusan",
                detail: "Butiran",
                qrcode_title: "Kod QR Penebusan"
            },
            check: {
                securitycheckscancode: "Penebusan Kupon",
                productscanstate: "Status Penebusan",
                coupon_id: "ID Kupon",
                coupon_verificationcode: "Kod Penebusan Kupon",
                coupon_name: "Nama Kupon",
                coupon_address: "Lokasi Penggunaan",
                coupon_scan_date: "Masa Penebusan",
                coupon_check_yes: "Penebusan Berjaya",
                coupon_check_no: "Penebusan Gagal",
                nav_check: "Penebusan Kupon",
                nav_list: "Rekod Penebusan"
            }
        },
        mainbody: {
            dealername: {
                top_title: "Sila masukkan nama penuh peniaga/syarikat yang ingin didaftarkan",
                tips: "*Sila isi dengan teliti dan pastikan nama konsisten dengan lesen perniagaan",
                label: "Nama Penuh Peniaga/Syarikat",
                bottom_content: "Seterusnya"
            },
            dealer: {
                toptitle: "Sila lengkapkan maklumat peniaga/syarikat",
                dealertype: "Jenis",
                fullname: "Nama Penuh Peniaga/Syarikat",
                filetype: "Jenis Dokumen",
                filetype_placeholder: "Kod Kredit Sosial Bersatu",
                file_image: "Gambar Dokumen",
                bottom_content: "Seterusnya",
                select_region_first: "Sila pilih negara/negeri/bandar/daerah dahulu",
                region_label: "Kawasan Dipilih",
                locate_on_map: "Lokasi",
                drag_marker_hint: "Masukkan alamat khusus dan klik lokasi; jika kedudukan tidak tepat, seret penanda peta untuk pelarasan halus",
                locate_building_approximate: "Lokasi kini di sekitar kawasan perumahan; Tianditu belum mempunyai koordinat tepat untuk bangunan ini, sila seret penanda ke bangunan tertentu",
                longitude: "Longitud",
                latitude: "Latitud",
                confirm_address: "Sahkan Alamat",
                enter_detail_address: "Sila masukkan alamat khusus",
                locate_failed: "Gagal mencari alamat, sila semak alamat atau seret penanda secara manual",
                confirm_address_invalid: "Sila masukkan alamat khusus dan sahkan lokasi pada peta dahulu",
                detail_address_title: "Sila masukkan alamat khusus",
                detail_address_subtitle: "Disarankan isi sehingga bangunan/nombor pintu; nombor tingkat tidak menjejaskan lokasi, penanda boleh diseret untuk pelarasan halus",
                map_placeholder: "Sila masukkan alamat khusus dan klik \"Lokasi\" dahulu, peta akan dipaparkan di sini",
                map_style_streets: "Standard",
                map_style_hybrid: "Satelit",
                map_switched_satellite: "Kawasan luar bandar telah bertukar ke peta satelit untuk melihat rupa bumi sebenar",
                map_panel_tianditu: "Pemilihan Titik Tianditu",
                map_panel_maptiler: "MapTiler",
                map_panel_maptiler_compare: "Perbandingan MapTiler (baca sahaja)",
                map_compare_hint: "Perbandingan dua peta sementara · berpandukan koordinat Tianditu · MapTiler memaparkan serentak selepas penanda Tianditu diseret",
                geocode_result_title: "Keputusan Lokasi",
                geocode_input_address: "Masukkan Alamat",
                geocode_matched_address: "Alamat Padanan",
                geocode_source: "Sumber Analisis",
                geocode_coord_system: "Sistem Koordinat",
                geocode_lnglat_pair: "lng,lat",
                geocode_level: "Tahap Ketepatan",
                geocode_manual_adjusted: "Telah Dilaraskan Secara Manual",
                geocode_approximate: "Lokasi Anggaran",
                geocode_copy_lnglat: "Salin Koordinat",
                geocode_copy_success: "Koordinat telah disalin",
                geocode_source_tianditu: "Tianditu",
                geocode_source_maptiler: "MapTiler"
            },
            dealeruser: {
                toptitle: "Sila lengkapkan maklumat orang hubungan",
                desc: "untuk melengkapkan pendaftaran",
                fill_real_name: "Sila masukkan nama sebenar",
                fill_fake_name: 'Isi nama pengguna',
                fill_captcha: "Sila masukkan kod pengesahan grafik",
                fill_sms_code: "Sila masukkan kod pengesahan SMS",
                register: "Daftar"
            },
            directvendor: {
                top_title: "Sila masukkan nama penuh pengedar terus yang ingin didaftarkan",
                label: "Nama Penuh Pengedar Terus"
            }
        },
        roleselect: {
            title: "Terima kasih kerana memilih Castrol",
            desc: "Sila pilih identiti yang ingin anda daftarkan",
            topdealer: "Pengedar Utama",
            directvendor: "Pengedar Terus",
            service: "Penyedia Perkhidmatan",
            consumer: "Pengguna",
            serviceprovider: "Kakitangan Perkhidmatan",
            other: "Lain-lain"
        },
        qrcoderegister: {
            scan_desc: "Imbas corak kod QR untuk menjadi",
            retailer_name: "Peruncit",
            dealer_name: "Pengedar",
            download: "Muat Turun",
            user: "Imbas corak kod QR untuk menyertai syarikat",
            copy: "Klik untuk menyalin pautan",
            copysuccess: "Disalin Berjaya",
            copyfail: "Gagal Menyalin"
        },
        worker: {
            submit_in: "Daftar Pekerja",
            topsearch: {
                title: "Sila masukkan nombor telefon pekerja untuk carian"
            },
            item: {
                user: "Nama Pengguna",
                phone: "Nombor Telefon"
            },
            detail: {
                id: "ID Pekerja",
                name: "Nama Sebenar",
                phone: "Nombor Telefon",
                delete: "Buang Pekerja",
                deletepopup: {
                    title: "Adakah anda pasti mahu membuang pekerja ini?",
                    confirm: "Sahkan",
                    cancel: "Batal"
                }
            }
        },
        serviceprovider: {
            fulladdress: "Alamat Khusus",
            belongserviceproviderinfo: "Penyedia Perkhidmatan Milikan"
        },
        distributor: {
            tipsone: "Pengedar atasan semasa tidak wujud",
            tipstwo: "Ralat menghuraikan data pengedar atasan semasa",
            parentinfo: "Pengedar Milikan"
        },
        retailer: {
            tipsone: "Peruncit milikan tidak wujud",
            tipstwo: "Ralat menghuraikan data peruncit milikan",
            parentinfo: "Pengedar Milikan",
            belongshopinfo: "Peruncit Milikan"
        },
        supplier: {
            tipsone: "Pembekal milikan tidak wujud",
            tipstwo: "Ralat menghuraikan data pembekal milikan",
            parentinfo: "Pembekal Milikan",
            item: {
                type: "Jenis"
            },
            tips: {
                warn: {
                    outboundtargettips: "Sila pilih sasaran pengeluaran dahulu"
                }
            }
        },
        directvendor: {
            tipsone: "Pengedar terus milikan tidak wujud",
            tipstwo: "Ralat menghuraikan data pengedar terus milikan",
            parentinfo: "Pengedar Terus Milikan"
        },
        loginroleselect: {
            title: "Sila pilih satu identiti untuk log masuk",
            desc: "Kami mengesan anda mempunyai pelbagai identiti, boleh ditukar selepas log masuk",
            system_user: "Pengguna Sistem",
            supplier_user: "Pembekal",
            distributor_user: "Pengedar",
            directvendor_user: "Pengedar Terus",
            retailer_user: "Peruncit",
            individual_user: "Pengguna",
            service_provider_user: "Penyedia Perkhidmatan",
            service_personnel: "Kakitangan Perkhidmatan"
        },
        newstock: {
            create: {
                addToStockDetail: "Tambah ke Ringkasan Stok",
                clearAllStockDetail: "Kosongkan Ringkasan Stok",
                createstock: "Cipta Stok",
                addToStockDetailFirst: "Sila tambah ke ringkasan stok dahulu",
                serialnumber: " Nombor Siri",
                enterserialnumber: "Sila masukkan nombor siri",
                tips: {
                    batch_input_tips: "Sila masukkan nombor siri secara pukal, gunakan baris baharu untuk memisahkan",
                    input_serialnumber: "Sila masukkan nombor siri",
                    check_all_count: "Jumlah dikenal pasti:"
                },
                detail: {
                    gostock: "Kemasukan",
                    serialnumberlist: "Senarai Nombor Siri",
                    success: "Penciptaan berjaya",
                    failed: "Penciptaan Gagal",
                    instock_success: "Kemasukan berjaya",
                    no_create_success_stock: "Tiada stok yang berjaya dicipta buat masa ini"
                }
            },
            in: {
                title_unstockin: "Menunggu Kemasukan",
                title_stockrecord: "Rekod Kemasukan",
                title_querystock: "Lihat Stok",
                scan_stock_in: "Imbas untuk Kemasukan",
                search_placeholder: "Sila masukkan nombor gulungan untuk carian",
                in_stock_date: "Tarikh Kemasukan",
                un_in_stock_count: "Jumlah Menunggu Kemasukan",
                in_stock_record_count: "Jumlah Rekod Kemasukan",
                plan_purchase_count: "Jumlah Pembelian",
                real_in_count: "Jumlah Kemasukan Sebenar",
                select_purchase_distributor: "Sila pilih pengedar atasan",
                select_warehouse: "Pilihan Gudang",
                confirm_select: "Sahkan Pilihan",
                skip_without_create_warehouse: "Langkau (Gudang Utama Lalai)",
                inconfirm: {
                    confirm_in: "Sahkan Kemasukan",
                    error_popup: "Anomali, sila sahkan semula sebelum kemasukan; nombor gulungan lain berjaya dimasukkan",
                    error_popup_one: "Anomali, sila sahkan semula sebelum kemasukan",
                    error_popup_two: "Produk ini tidak dalam skop kemasukan, sila semak dan cuba semula",
                    error_popup_three: "Sebahagian nombor gulungan tidak dalam skop kemasukan, sila semak dan cuba semula",
                    newscan: "Imbas Semula",
                    in_success: "Kemasukan berjaya",
                    novalid_in: "Input Tidak Sah"
                },
                stock: {
                    count: "Kuantiti:",
                    stock_all_count: "Jumlah Stok:",
                    stockin: "Telah Dimasukkan",
                    info: "Maklumat Pergerakan",
                    instock: "Dalam Stok",
                    instock_time: "Masa Kemasukan",
                    warehouse_name: "Nama Penuh Gudang"
                }
            },
            out: {
                title_unstockout: "Menunggu Pengeluaran",
                title_stockrecord: "Rekod Pengeluaran",
                title_querystock: "Lihat Stok",
                search_placeholder: "Sila masukkan nombor gulungan untuk carian",
                title: "Masa:",
                out_stock_time: "Tarikh Pengeluaran",
                out_stock_time_two: "Masa Pengeluaran",
                out_stock_record_count: "Jumlah Rekod Pengeluaran",
                plan_purchase_count: "Jumlah Pembelian",
                real_out_count: "Jumlah Pengeluaran Sebenar",
                unout: {
                    select_purchase_distributor: "Sila pilih pengedar/peruncit pembelian",
                    select_outbount_targetobject: "Sila pilih sasaran pengeluaran",
                    scan_out: "Imbas untuk Pengeluaran",
                    summary_kind_label: "Jenis Produk",
                    summary_kind_unit: "jenis",
                    summary_pending_label: "Jumlah Menunggu Pengeluaran",
                    no_select_distributor: "Sila pilih pengedar dahulu",
                    no_select_targetobject_desc: "Sila pilih sasaran pengeluaran dahulu",
                    search_outbound_target_name: "Sila masukkan nama untuk mencari",
                    distributor_un_out_count: "Kuantiti menunggu pengeluaran untuk pengedar/peruncit ini",
                    targetobject_un_out_count: "Kuantiti menunggu pengeluaran untuk sasaran ini",
                    out_count: "Kuantiti Pengeluaran",
                    plannedpurchase_count: "Kuantiti Pembelian Dirancang",
                    out_count_new: "Kuantiti Pengeluaran Sebenar",
                    plannedpurchase_count_new: "Kuantiti Pembelian"
                },
                outconfirm: {
                    confirm_in: "Sahkan Pengeluaran",
                    error_popup: "Anomali, sila sahkan semula sebelum pengeluaran; nombor gulungan lain berjaya dikeluarkan",
                    error_popup_one: "Anomali, sila sahkan semula sebelum pengeluaran",
                    error_popup_two: "Produk ini tidak dalam skop pengeluaran, sila semak dan cuba semula",
                    error_popup_three: "Sebahagian nombor gulungan tidak dalam skop pengeluaran, sila semak dan cuba semula",
                    newscan: "Imbas Semula",
                    in_success: "Pengeluaran berjaya",
                    novalid_in: "Input Tidak Sah"
                },
                unoutdetail: {
                    tag_unout: "Menunggu Pengeluaran",
                    scan_out: "Imbas untuk Pengeluaran",
                    confirm_out: "Sahkan Pengeluaran",
                    serial: "Nombor Gulungan",
                    check_product_error: "Produk ini tidak sepadan dengan nombor gulungan, sila semak dan cuba semula",
                    stock_out_success: "Pengeluaran berjaya",
                    all: "Semua",
                    all_new: "Semua Peniaga"
                }
            }
        },
        selectrolepopup: {
            changerole: "Tukar Peranan",
            createnewrole: "Cipta Identiti Baharu",
            searchplaceholder: "Cari jenis peranan atau nama syarikat",
            clearsearch: "Kosongkan",
            totalroles: "{count} peranan tersedia",
            noresults: "Tiada peranan yang sepadan ditemui",
            noresultsdesc: "Sila cuba kata kunci lain, seperti nama pengedar atau jenis peranan"
        },
        qastepform: {
            multi_product_incomplete: "Terdapat maklumat yang belum lengkap",
            steporigin: {
                stepone: "1. Imbas maklumat produk -",
                steptwo: "2. Isi maklumat kenderaan -",
                stepthree: "3. Muat naik gambar pemasangan -",
                stepfour: "4. Hantar dan selesai"
            },
            stepone: {
                scantop: "Langkah 1: Imbas Maklumat Produk",
                productname: "Nama Produk",
                serialnumber: "Nombor Gulungan",
                expiredate: "Tempoh Waranti",
                qacontent: "Kandungan Waranti",
                retailer: "Peruncit",
                record_product: "Produk Direkod",
                delete: "Buang",
                next: "Teruskan Input",
                submit: "Tamat Input\nSeterusnya",
                rollnumberplaceholder: "Sila masukkan nombor gulungan",
                rollnumberverify: "Sahkan",
                scanProductInfo: "Imbas untuk mendapatkan maklumat produk",
                scanProductInfoError: "(Jika pengecaman gagal, sila masukkan nombor gulungan secara manual untuk pengesahan)",
                popup: {
                    tips_title: "Petunjuk",
                    role_not_match_create_qa: "Peranan akaun semasa tidak sepadan, tidak dapat mencipta waranti",
                    title: "Adakah anda pasti mahu membuang nombor gulungan ini?",
                    confirm: "Sahkan",
                    cancel: "Batal",
                    retailer_confirm_title: "Sahkan Kedai Waranti",
                    retailer_confirm_lead: "Barangan ini telah dimasukkan ke",
                    retailer_confirm_tail: "，sila sahkan sama ada ingin mencipta waranti di kedai ini.",
                    retailer_confirm_yes: "Cipta di Kedai Ini",
                    retailer_confirm_no: "Kedai Tidak Tepat",
                    retailer_not_match_title: "Tidak Dapat Mencipta Waranti",
                    retailer_not_match_lead: "Barangan ini telah dimasukkan ke",
                    retailer_not_match_tail: "，tidak konsisten dengan kedai semasa, tidak dapat meneruskan penciptaan waranti. Jika perlu bantuan, sila hubungi kedai tersebut atau khidmat pelanggan.",
                    retailer_not_match_confirm: "Faham"
                },
                toast: {
                    select_component: "Sila pilih bahagian pemasangan",
                    no_repeat_scan: "Sila jangan mengimbas nombor gulungan berulang kali",
                    roll_number_noempty: "Nombor gulungan tidak boleh kosong",
                    rollnumberverify_success: "Pengesahan Berjaya",
                    distributor_channel_hint: "Produk ini tergolong dalam saluran pengedaran; waranti perlu dicipta oleh peruncit, atau selepas kemasukan stok baru boleh mencipta waranti.\nTerima kasih atas kefahaman anda!"
                }
            },
            setptwo: {
                scantop: "Langkah 2: Isi Maklumat Kenderaan",
                carinfo: "Maklumat Kenderaan",
                carownername: "Nama Pemilik",
                inputcarownername: "Sila masukkan nama pemilik",
                next: "Seterusnya",
                serialnumber: "Nombor Gulungan",
                toast: {
                    answer_fill_all: "Sila semak sama ada soal selidik telah dilengkapkan",
                    carownername_fill_all: "Sila isi nama pemilik",
                    phone_fill_all: "Sila isi nombor telefon",
                    code_fill_all: "Sila isi kod pengesahan",
                    content_check_failed: "Sila masukkan kandungan yang betul",
                    singlechoice_check_failed: "Sila pilih data",
                    answer_fill_all_yes: "Sila semak sama ada kandungan soal selidik diisi dengan betul"
                }
            },
            stepthree: {
                scantop: "Langkah 3: Muat Naik Gambar Pemasangan",
                ztimg: "Gambar Pemasangan",
                serialnumber: "Nombor Gulungan",
                least: "Sekurang-kurangnya",
                most: "Maksimum",
                unit: "gambar",
                show_below_info: "Sila tambah gambar jarak dekat pemasangan setiap komponen di bawah",
                toast: {
                    success: "Penciptaan berjaya",
                    img_upload_failed: "Bilangan gambar yang dimuat naik tidak sepadan"
                }
            },
            redesign: {
                common: {
                    step_title: "Langkah {step} · {title}",
                    product_progress: "Produk {current} / {total}",
                    product_tab: "Produk {index}",
                    prev_product: "Sebelumnya",
                    next_product: "Seterusnya",
                    need_help: "Perlukan bantuan?",
                    input_mode_aria: "Kaedah Input",
                    list_separator: "、"
                },
                stepone: {
                    verify_success_label: "Pengesahan nombor gulungan berjaya:",
                    task_desc: "Masukkan secara manual atau imbas untuk mendapatkan nombor gulungan; selepas pengesahan, maklumat produk dan komponen akan dipaparkan",
                    manual_input: "Input Manual",
                    scan_input: "Imbas untuk Mendapatkan",
                    select_warranty_parts: "Pilih Komponen Waranti",
                    parts_selected: "Dipilih {selected}/{total}",
                    continue_entry_title: "Teruskan Input Produk",
                    entry_title: "Input Produk",
                    entry_status_current_total: "Sedang memasukkan produk ke-{index} · daripada {total}",
                    entry_status_current: "Sedang memasukkan produk ke-{index}"
                },
                steptwo: {
                    task_desc_single: "Isi soal selidik kenderaan dan maklumat hubungan pemasangan",
                    task_desc_multi: "Setiap produk diisi soal selidik kenderaan secara berasingan; tarikh pemasangan dan nombor telefon dikongsi merentas produk",
                    switch_product_hint: "Sila gunakan butang di bawah untuk menukar produk dan melengkapkan semua soal selidik kenderaan",
                    mount_and_contact: "Pemasangan & Hubungan",
                    multi_product_shared: "Dikongsi Merentas Produk",
                    shared_hint_default: "Tarikh pemasangan dan nombor telefon pemilik hanya perlu diisi sekali untuk semua produk",
                    shared_hint_zhongsheng: "Tarikh pemasangan hanya perlu diisi sekali",
                    account_phone: "Nombor Telefon Akaun",
                    change_phone: "Tukar Nombor Telefon",
                    fill_owner_phone: "Sila isi nombor telefon pemilik",
                    use_account_phone: "Gunakan Maklumat Akaun",
                    privacy_dialog_title: "Notis Privasi",
                    privacy_dialog_message: "Disebabkan cadangan privasi saluran 【Kumpulan Zhongsheng】, 【nama sebenar pemilik】 dan 【nombor telefon】 disyorkan untuk dirahsiakan. Adakah anda membenarkan penggunaan nama 【{name}】 dan nombor telefon 【{phone}】 akaun semasa?",
                    privacy_dialog_confirm: "Sahkan Kebenaran",
                    privacy_dialog_manual: "Isi Manual",
                    toast_creator_info_applied: "Maklumat akaun anda telah digunakan",
                    toast_account_phone_applied: "Nombor telefon akaun telah digunakan",
                    toast_no_account_phone: "Akaun tidak diikat dengan nombor telefon, sila isi secara manual"
                },
                stepthree: {
                    task_desc_single: "Muat naik gambar pemasangan dan jarak dekat komponen mengikut keperluan waranti",
                    task_desc_multi: "Untuk pelbagai produk, sila muat naik gambar pemasangan secara berasingan menggunakan butang di bawah",
                    switch_product_hint: "Sila gunakan butang di bawah untuk menukar produk dan melengkapkan semua gambar pemasangan",
                    warranty_files_title: "Fail Waranti",
                    warranty_files_desc: "Gambar pemasangan kenderaan dan berkaitan nombor gulungan",
                    component_closeup_title: "Jarak Dekat Komponen",
                    component_closeup_desc: "Gambar jarak dekat setiap komponen pemasangan",
                    pending_upload_hint: "Produk {products} masih mempunyai foto yang menunggu untuk dimuat naik"
                }
            }
        },
        qapublicquery: {
            hero_title: "Siasatan Waranti Filem Kereta",
            hero_desc: "Masukkan nombor casis untuk menyemak maklumat waranti rasmi",
            logo_alt: "Castrol Auto Films",
            search_card_title: "Siasatan Nombor Casis",
            search_card_hint: "Sila masukkan nombor casis (VIN) yang lengkap",
            trust_no_login: "Tanpa Log Masuk",
            trust_instant: "Siasatan Segera",
            trust_official: "Waranti Rasmi",
            guide_phone: "Nombor Telefon",
            guide_or: "atau",
            guide_vin: "Nombor Casis",
            guide_result: "Lihat Keputusan",
            landing_title: "Mula Siasatan",
            landing_desc: "Masukkan nombor casis dan klik cari untuk melihat butiran waranti",
            landing_caption: "Selepas siasatan, maklumat waranti penuh boleh dilihat",
            landing_tap_hint: "Klik kad di atas untuk bermula",
            landing_preview_code: "Nombor Waranti",
            landing_preview_product: "Nama Produk",
            landing_preview_period: "Tempoh Sah Waranti",
            landing_feature_status: "Status Waranti",
            landing_feature_detail: "Butiran Produk",
            landing_feature_verify: "Pengesahan Rasmi",
            empty_title: "Tiada rekod waranti ditemui",
            loading: "Sedang menyiasat, sila tunggu…",
            result_count: "{count} rekod waranti ditemui",
            result_found: "Rekod waranti ditemui",
            vin_required: "Sila masukkan nombor casis",
            mock_notice: "Ini ialah data demo buat masa ini; keputusan sebenar akan dipaparkan selepas antara muka rasmi disambungkan",
            search_failed: "Siasatan gagal, sila cuba semula kemudian",
            warranty_not_found: "Tiada rekod waranti yang sepadan ditemui",
            login_guide_title: "Perlukan lebih banyak perkhidmatan?",
            login_guide_desc: "Selepas log masuk, anda boleh mencipta waranti, mengurus pesanan dan menggunakan fungsi perniagaan penuh",
            login_guide_action: "Siasatan Nombor Telefon",
            create_qa_action: "Cipta Waranti",
            float_actions_expand: "Kembangkan Tindakan Pantas",
            float_actions_collapse: "Lipat Tindakan Pantas"
        },
        qasteplist: {
            topphonesearch: "Sila masukkan nombor telefon untuk carian",
            search: {
                hint: "Menyokong carian nombor telefon atau nombor casis",
                vin_hint: "Menyokong carian nombor casis",
                phone_label: "Nombor Telefon",
                phone_placeholder: "Sila masukkan nombor telefon",
                vin_label: "Nombor Casis",
                vin_placeholder: "Sila masukkan nombor casis",
                submit: "Cari",
                reset: "Kosongkan",
                require_one: "Sila masukkan sekurang-kurangnya nombor telefon atau nombor casis",
                require_vin: "Sila masukkan nombor casis",
                empty_desc: "Tiada rekod waranti yang sepadan\nAnda boleh melaraskan syarat carian dan cuba semula",
                edit: "Ubah"
            },
            list_meta: "{count} rekod",
            list_lead: "Rekod waranti yang ditemui",
            list_empty_lead: "Tiada rekod waranti",
            tab: {
                all: "Semua",
                unapprove: "Menunggu Berkuat Kuasa",
                approved: "Telah Berkuat Kuasa",
                rejected: "Ditolak"
            },
            item: {
                product: "Produk",
                phone: "Nombor Telefon",
                vin: "Nombor Casis",
                unapprove: "Menunggu Berkuat Kuasa",
                approved: "Telah Berkuat Kuasa",
                rejected: "Ditolak"
            }
        },
        qastepreview: {
            search: "Tapis",
            tab: {
                all: "Semua",
                unapprove: "Menunggu Semakan",
                approved: "Telah Diluluskan",
                rejected: "Ditolak"
            },
            item: {
                product: "Produk",
                phone: "Nombor Telefon",
                unapprove: "Menunggu Semakan",
                approved: "Telah Diluluskan",
                rejected: "Ditolak"
            },
            review_success: "Semakan Berjaya"
        },
        qastepdetail: {
            qastatus: "Status Waranti",
            carinfo: "Maklumat Kenderaan",
            productname: "Nama Produk",
            serialnumber: "Nombor Gulungan",
            expireddate: "Tempoh Waranti",
            qacontent: "Kandungan Waranti",
            mountparts: "Komponen Pemasangan",
            qastarttime: "Tarikh Mula Waranti",
            mountinfo: "Maklumat Pemasangan",
            mounttime: "Tarikh Pemasangan",
            retailer: "Peruncit",
            zt_img: "Gambar Waranti",
            review: "Semakan",
            carownername: "Nama Pemilik",
            carownerphone: "Nombor Telefon Pemilik",
            unapprove: "Menunggu Berkuat Kuasa",
            approved: "Telah Berkuat Kuasa",
            rejected: "Ditolak",
            screenshot: {
                save: "Simpan Tangkapan Skrin Panjang",
                capturing: "Sedang menjana tangkapan skrin panjang",
                capturing_hint: "Sedang menyusun kandungan halaman, sila tunggu",
                capturing_slice: "Sedang mencantum bahagian {current}/{total}",
                capturing_saving: "Sedang menyimpan gambar",
                saved: "Tangkapan skrin panjang telah disimpan",
                segmented: "Kandungan agak panjang, {count} tangkapan skrin bahagian telah disimpan",
                preview_title: "Pratonton Tangkapan Skrin Panjang",
                preview_hint: "Tekan lama gambar untuk menyimpan ke album",
                preview_close: "Tutup Pratonton",
                preview_prev: "Sebelumnya",
                preview_next: "Seterusnya"
            },
            qrcode: {
                open: "Kongsi",
                hint: "Selepas mengimbas, maklumat waranti ini boleh dilihat",
                missing_vin: "Tiada nombor casis, tidak dapat menjana kod QR",
                save: "Simpan ke Album",
                save_hint: "Tekan lama gambar untuk menyimpan ke album",
                saved: "Kod QR telah disimpan",
                save_fail: "Gagal menyimpan, sila cuba semula",
                copy_link: "Salin Pautan",
                copy_success: "Pautan disalin",
                copy_fail: "Gagal menyalin, sila cuba semula",
                close: "Tutup"
            },
            ppf_warranty: {
                detail_title: "Butiran Skop Waranti",
                detail_link: "Butiran",
                detail_html: "<h5>Kekotoran, rekahan, pengelupasan, kesan hujan, kecacatan permukaan filem yang jelas sebelum pemasangan, kekuningan dan hidrolisis yang disebabkan oleh faktor bukan manusia adalah dalam skop waranti.</h5><h5>Butiran skop waranti:</h5><ol class=\"ppf-list\"><li>Kekotoran merujuk kepada permukaan filem yang hilang kilau dan kelihatan kusam;</li><li>Rekahan merujuk kepada permukaan filem yang rapuh dan mengalami keretakan;</li><li>Pengelupasan merujuk kepada lapisan pelekat yang terpisah sendiri daripada lapisan filem selepas pemasangan dan penggunaan normal;</li><li>Kesan hujan merujuk kepada kesan yang sangat jelas dan tidak dapat ditanggalkan yang ditinggalkan oleh air hujan pada permukaan filem;</li><li>Kecacatan permukaan yang jelas sebelum pemasangan merujuk kepada keadaan yang hanya boleh didapati sebelum pemasangan, iaitu bintik putih, bendasing yang jelas, gel, corak condong yang jelas dan sebagainya;</li><li>Kekuningan merujuk kepada permukaan filem yang bertukar kuning dengan jelas; kekuningan ringan adalah normal dan tidak termasuk dalam skop waranti, iaitu ΔE&lt;2, tiada tanggungjawab selepas jualan;</li><li>Hidrolisis merujuk kepada filem yang telah cair pada permukaan cat kereta dan tidak boleh dikeluarkan;</li><li>Leret tepi (leret tepi selepas satu bulan daripada siap pemasangan dan serahan adalah dalam waranti; dalam tempoh satu bulan ia dianggap sebagai isu teknikal pemasangan, kembali ke kedai untuk pembetulan semula).</li></ol><h5>Nota:</h5><p>Filem kereta yang tercemar oleh cecair cuci kereta, pembersih tar, tar atau bahan kimia lain tidak termasuk dalam skop waranti.</p>",
                detail_aria: "Lihat Butiran Skop Waranti"
            }
        },
        distributorcoupon: {
            topsearch: {
                content: "Sila masukkan nombor telefon untuk carian",
                search: "Cari"
            },
            tabs: {
                all: "Semua",
                undo: "Belum Ditebus",
                done: "Telah Ditebus"
            },
            phone: "Nombor Telefon",
            scan: {
                submit: "Sahkan Penebusan",
                scan_success: "Penebusan Berjaya"
            }
        },
        newdealershop: {
            fullname: "Nama Penuh Peniaga/Syarikat",
            area: "Kawasan",
            address: "Alamat",
            level: "Tahap",
            createtime: "Masa Penciptaan",
            cartype: "Jenis Dokumen",
            carimg: "Gambar Dokumen"
        },
        newpurchasedetail: {
            product_info: "Maklumat Produk",
            purchase_id: "ID Pesanan Pembelian",
            purchase_date: "Tarikh Pembelian",
            purchase_people: "Pembeli",
            purchase_people_phone: "Nombor Telefon Pembeli",
            distributor_info: "Maklumat Pengedar",
            company_name: "Nama Syarikat",
            people_number: "Nombor Pengenalan Pembayar Cukai",
            address: "Alamat",
            phone: "Telefon"
        },
        newpurchasemanagerdetail: {
            product_info: "Maklumat Produk",
            purchase_id: "ID Pesanan Pembelian",
            purchase_date: "Tarikh Pembelian",
            purchase_company: "Pihak Pembeli",
            purchase_people: "Pembeli",
            purchase_people_phone: "Nombor Telefon Pembeli"
        },
        shoporder: {
            orderlist: "Senarai Transaksi",
            goorder: "Beli",
            style: "Model",
            no_sku_price_tips: "Tiada Harga",
            current_sku_no_price_tips: "SKU semasa tidak boleh membuat pesanan",
            first_select_address: "Sila pilih alamat dahulu",
            create_payment_success: "Penciptaan berjaya",
            go_to_payment: "Adakah anda mahu membuat pembayaran sekarang?\nJika belum dibayar, anda boleh meneruskan pembayaran dalam butiran pesanan",
            payment_create_confirm: "Cipta",
            payment_create_back: "Kembali",
            please_retry_select_goods: "Produk yang dipilih tiada harga, sila pilih semula",
            all_price: "Jumlah",
            search: {
                search_input_order_placeholder: "Sila masukkan ID pesanan untuk carian",
                search_input_payment_placeholder: "Sila masukkan ID slip pembayaran untuk carian"
            },
            orderitem: {
                orderid: "ID Pesanan",
                channelinfo: "Saluran",
                orderdate: "Tarikh Pesanan",
                orderperson: "Pembuat Pesanan",
                orderphone: "Nombor Telefon Pembuat Pesanan",
                buyerpartytype: "Jenis Pihak Pesanan",
                buyerpartyname: "Pihak Pesanan",
                buy_from: "Pembeli",
                paymentorderid: "ID Slip Pembayaran",
                paymentorderbuyertype: "Jenis Pihak Pembayaran",
                paymentorderbuyername: "Pihak Pembayaran",
                createorderdate: "Tarikh Penciptaan",
                paymentorderdate: "Tarikh Pembayaran",
                confirmorderdate: "Tarikh Pengesahan",
                paymentorderinfo: "Maklumat Slip Pembayaran",
                orderamount: "Amaun Pesanan",
                orderaddress: "Alamat",
                changestatus: "Ubah Status",
                statusscuess: "Kemas kini status berjaya",
                change_status_confirming: "Menunggu Pengesahan",
                change_status_confirmed: "Sahkan",
                change_status_closed: "Tutup",
                payment_method: "Kaedah Pembayaran",
                payment_time: "Masa Pembayaran",
                payment_time_now: "Masa Semasa",
                payment_time_manual: "Pelarasan Manual",
                id: "ID"
            },
            orderdetail: {
                gobuy: "Cipta Slip Pembayaran",
                viewgodetail: "Lihat Butiran Penghantaran",
                gosend: "Ke Penghantaran",
                sku_amount: "Amaun SKU",
                distribution_costs: "Kos Penghantaran",
                sku_reduce: "Potongan SKU",
                discount_amount: "Amaun Diskaun",
                really_pay: "Bayaran Sebenar",
                channel_title: "Maklumat Saluran",
                channel_id: "ID Saluran",
                channel_name: "Nama Saluran",
                channel_type: "Jenis Saluran",
                buyer_title: "Maklumat Pembeli",
                buyer_title_order: "Maklumat Pesanan",
                store_title: "Maklumat Kedai",
                order_info: "Maklumat Pesanan",
                store_id: "ID Kedai",
                store_name: "Nama Kedai",
                pricedetail: "Butiran Harga",
                paymentmethod: "Kaedah Pembayaran",
                orderpayment: "Butiran Slip Pembayaran",
                watch_bank_info: "Lihat Maklumat Kad Bank",
                up_bank_info: "Lipat",
                createorder: "Cipta Pesanan",
                padding_pay_amount: "Amaun Menunggu Pembayaran",
                padding_confirming_amount: "Amaun Menunggu Pengesahan",
                confirmed_amount: "Amaun Disahkan",
                paymentamount: "Amaun Perlu Dibayar",
                createpaytime: "Masa Penciptaan",
                buyerpartid: "ID Pembeli",
                buyertype: "Jenis Pembeli",
                buyerstyle: "Jenis Pembeli",
                buyerpartname: "Nama Pembeli",
                buyerpeople: "Pembuat Pesanan",
                buyerphonenumber: "Nombor Telefon Pembuat Pesanan",
                buyerpeople_new: "Pembayar",
                buyerphonenumber_new: "Telefon Pembayar",
                order_id: "ID Pesanan",
                order_time: "Masa Pesanan",
                order_status: "Status Pesanan",
                formatted: "Format",
                added: "Tambah",
                select_full_date: "Pilih Masa Penuh",
                full_date_year: "tahun",
                full_date_month: "Bulan",
                full_date_day: "Hari",
                full_date_hour: "Jam",
                full_date_minute: "Minit",
                full_date_second: "Saat",
                confirm: "Sahkan",
                cancel: "Batal",
                alipay_redirecting: "Membuka pembayaran Alipay, sila tunggu…",
                alipay_querying: "Menyemak status pembayaran, sila tunggu…",
                alipay_success: "Pembayaran berjaya",
                alipay_back: "Kembali",
                alipay_scan_tip: "Imbas dengan Alipay untuk membayar",
                alipay_scan_sub: "Pembayaran akan dikesan secara automatik",
                buyer_title_order_new: "Maklumat Pembayar",
                order_info_new: "Maklumat Pesanan",
                buyer_title_new_title: "Maklumat Pihak Pembayaran",
                buyerpartid_new: "ID Pihak Pembayaran",
                buyerstyle_new: "Jenis Pihak Pembayaran",
                buyerpartname_new: "Nama Pihak Pembayaran",
                transactionNo_detail: "Nombor Transaksi",
                enter_transactionNo: "Sila masukkan nombor transaksi",
                confirm_date: "Masa Pengesahan",
                payment_date: "Masa Pembayaran"
            },
            ordermanager: {
                tab: {
                    all: "Semua",
                    unpay: "Menunggu Pembayaran",
                    unconfirmed: "Menunggu Pengesahan",
                    partpay: "Pengesahan Sebahagian",
                    payed: "Telah Disahkan",
                    closed: "Telah Ditutup"
                }
            },
            stockout: {
                totalQty: "Jumlah Kuantiti",
                pendingOutboundQty: "Kuantiti Menunggu Pengeluaran",
                pendingInboundQty: "Kuantiti Menunggu Kemasukan",
                inboundQty: "Kuantiti Telah Dimasukkan",
                outboundtime: "Masa Pengeluaran",
                outboundoperation: "Keterangan Pengeluaran",
                outboundoperation_placeholder: "Sila masukkan keterangan pengeluaran"
            },
            store: {
                storeid: "ID",
                storename: "Nama"
            }
        },
        service: {
            servicecenter: {
                search_input_servicecenter_placeholder: "Sila masukkan nama pusat servis untuk carian",
                create: "Cipta Pusat Servis",
                creation: {
                    name: "Nama Pusat Servis",
                    workcount: "Bilangan Stesen Kerja",
                    confirm: "Sahkan",
                    confirmcreate: "Sahkan Ciptaan",
                    create_success_tips: "Pusat servis berjaya dicipta"
                },
                detail: {
                    name: "Nama Pusat Servis",
                    address: "Kawasan",
                    fulladdress: "Alamat",
                    contractphone: "Nombor Telefon Hubungan",
                    workcount: "Bilangan Stesen Kerja"
                }
            },
            manager: {
                search: {
                    content: "Sila masukkan nama perkhidmatan"
                },
                tab: {
                    all: "Semua",
                    not_scheduled: "Belum Ditemu Janji",
                    scheduled: "Telah Ditemu Janji",
                    served: "Telah Dilayan",
                    not_required: "Tiada Perkhidmatan Diperlukan"
                },
                detail: {
                    amount_all: "Jumlah Keseluruhan"
                }
            }
        },
        address: {
            list: {
                search_input_address_placeholder: "Sila masukkan alamat untuk carian",
                create: "Tambah Alamat"
            },
            create: {
                owneraddress: "Kawasan",
                fulladdress: "Alamat Terperinci & Nombor Pintu",
                name: "Nama Penerima",
                saveaddress: "Simpan Alamat",
                successtips: "Alamat berjaya dicipta"
            },
            detail: {
                country: "Negara/Kawasan",
                fulladdress: "Alamat Terperinci",
                recipientName: "Nama Penerima",
                phone: "Nombor Telefon"
            }
        },
        warehouse: {
            list: {
                search_input_address_placeholder: "Sila masukkan nama gudang untuk carian",
                create: "Tambah Gudang"
            },
            create: {
                owneraddress: "Kawasan",
                fulladdress: "Alamat Terperinci & Nombor Pintu",
                name: "Nama Penuh Gudang",
                savewarehouse: "Simpan Gudang",
                successtips: "Gudang berjaya dicipta"
            },
            detail: {
                first_select_warehouse: "Sila pilih gudang dahulu",
                verify: "Pengesahan",
                confirm: "Sahkan"
            }
        },
        storemanager: {
            detail: {
                fullname: "Nama Kedai",
                salesStatus: "Status Jualan",
                shoplogo: "Logo Kedai"
            }
        },
        charts: {
            qachart: {
                name: "Laporan Waranti"
            },
            purchasechart: {
                name: "Laporan Pembelian"
            },
            inoutstockchart: {
                name: "Laporan Kemasukan & Pengeluaran"
            }
        },
        apptheme: {
            themesystem: "Tukar Skim Latar Belakang"
        },
        errorinfopopup: {
            title: "Maklumat Anomali",
            detail: "Butiran",
            close: "Tutup"
        },
        logout: {
            title: "Adakah anda pasti mahu log keluar?",
            confirm: "Sahkan",
            cancel: "Batal"
        },
        docker: {
            website: "Laman Utama",
            main: "Peta",
            scheme: "Skim",
            mine: "Saya"
        }
    },
};
